/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = exports.LocationLocationType = exports.AvailabilityLocationType = void 0;
var AvailabilityLocationType;
(function (AvailabilityLocationType) {
    AvailabilityLocationType["UNDEFINED"] = "UNDEFINED";
    AvailabilityLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    AvailabilityLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    AvailabilityLocationType["CUSTOM"] = "CUSTOM";
})(AvailabilityLocationType = exports.AvailabilityLocationType || (exports.AvailabilityLocationType = {}));
var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNKNOWN_LOCATION_TYPE"] = "UNKNOWN_LOCATION_TYPE";
    LocationLocationType["BUSINESS"] = "BUSINESS";
    LocationLocationType["CUSTOM"] = "CUSTOM";
    LocationLocationType["CUSTOMER"] = "CUSTOMER";
})(LocationLocationType = exports.LocationLocationType || (exports.LocationLocationType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
//# sourceMappingURL=types.js.map